import { Component } from '@angular/core';
import { AppService } from '../app.service';
import {StateService} from '../state.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-authentication-login-and-register',
  templateUrl: './authentication-login-and-register.component.html',
  styleUrls: [
    './authentication-login-and-register.component.scss'
  ]
})
export class AuthenticationLoginAndRegisterComponent {

  constructor(private appService: AppService, private stateService: StateService, private router: Router) {
    this.appService.pageTitle = 'Otentica - Login';
  }

  showLoginError: boolean = false;

  loginCredentials = {
    email: '',
    password: '',
    rememberMe: false
  };

  registerCredentials = {
    name: '',
    email: '',
    password: ''
  };

  public doLogin(): void {
    let loginSucceeded: boolean = this.stateService.login(this.loginCredentials.email);
    if(loginSucceeded) {
      this.router.navigate(['/']);
    }
    else {
      this.showLoginError = true;
    }
  }

}
